import { useState } from "react";
import RecipeCard from "./RecipeCard";
import RecipeSummaryCard from "./RecipeSummaryCard";

export default function RecipeMessage({ recipe }) {
  const [isOpen, setIsOpen] = useState(true);//set to false for closed by default

  return (
    <div className="w-full lg:max-w-[80%]">
      {!isOpen ? (
        <div className="flex justify-between items-center">
          <span className="font-semibold">{recipe.name}</span>
          <button
            className="text-sm text-blue-600 hover:underline"
            onClick={() => setIsOpen(true)}
          >
            View Recipe
          </button>
        </div>
      ) : (
        <div className="space-y-2">
          <RecipeSummaryCard recipe={recipe} />
          {/*  
          <div className="flex justify-end">
            <button
              className="text-sm text-gray-500 hover:underline"
              onClick={() => setIsOpen(false)}
            >
            Hide Recipe 
            </button>
          </div>
          */}
        </div>
      )}
    </div>
  );
}
